export enum ContractorViewMode {
  All = 'all',
  Home = 'home',
  TaskForce = 'taskForce',
}
